<div class="pageheader">
    <div class="page-title">
        <h1>Partner Contact Types</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">
                Refresh <ep-svg-icon icon="repeat"></ep-svg-icon>
            </button>
            <app-change-log-link *bizPermissionRequired="'Partner_Action_ShowLog'">
                <app-change-log-link-entity type="ContactType"></app-change-log-link-entity>
            </app-change-log-link>
        </div>
    </div>
</div>

<dx-data-grid biz-grid
              [showIsLoading]="isLoading"
              [dataSource]='contactTypes'
              (onInitNewRow)="initNewContactTypeRow($event)"
              (onRowRemoving)="onRowRemoving($event)"
              (onRowUpdated)="handleContactTypeSave($event)"
              (onRowInserted)="handleContactTypeSave($event)">
    <dxo-editing mode="row"
                 [allowUpdating]="allowUpdating"
                 [allowAdding]="allowAdding"
                 [allowDeleting]="allowDeleting"></dxo-editing>

    <dxi-column dataField="Name" caption="Name" dataType="string" sortOrder="asc">
        <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>
</dx-data-grid>
